import React, { ReactElement } from 'react';

import { useStore } from '@vromo/mobx-react';
import { observer } from 'mobx-react-lite';
import { RootStore } from '@vromo/dashboard/src/stores/RootStore';
import { userAccessByPosition, UserAccessOrder, UserAccessTypes } from '@vromo/api';




export const permissionsCheck = (requiredPosition: UserAccessTypes, positionId?: number | null): boolean => {

    return positionId != null && 
        UserAccessOrder.some((p) => p === requiredPosition) && 
        (
            UserAccessOrder.findIndex((p) => p === userAccessByPosition(positionId)) <=
            UserAccessOrder.findIndex((p) => p === requiredPosition)
        );
}


interface PermissionsProps {
    children: ReactElement;
    minPosition: UserAccessTypes;
}

export default observer(function Permissions({ minPosition, children }: PermissionsProps) {
    const rootStore = useStore<RootStore>('rootStore');
    const position = rootStore.authStore.role.position?.id;
    const hasAuth = permissionsCheck(minPosition, position);
    return hasAuth ? <>{children}</> : null;
});
